import { Dispatch } from 'redux'
import { Logger } from 'DVWebNodeUtils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  triggerPurchasingTransition,
  resetPurchasingTransition,
  failedPurchasingDueToClientDependency
} from '../actionBox'
import { startPurchase, PurchaseError } from '../../integrations/purchase'
import { refreshMainActionBox, refreshBtfActionBoxes, refreshEpisode } from '../wps'
import { safeBoolean } from '../../utils/utils'
import { store } from '../../store'
import { whisperCacheDataSelector } from '../../selectors/player'
import { auiModules } from '../../utils/promises'
import { Player } from '../../integrations/player'

const COUNTER_PARALLEL_PURCHASES = 'DVWebNodeDetail-ParallelAuiPurchases'
let parallelPurchases = 0


export type RefreshAfterPurchase = {
  pageTitleId: string,
  offerAsin: string,
  canonicalTitleId?: string,
  isSeasonPurchase: boolean,
  logger: Logger
}
export const refreshAfterPurchaseActionDispatcher = async ({ pageTitleId, offerAsin, canonicalTitleId, isSeasonPurchase, logger }: RefreshAfterPurchase) => {
  const promises = []
  promises.push(refreshMainActionBox(pageTitleId, offerAsin, canonicalTitleId ))
  if (safeBoolean(isSeasonPurchase)) {
    promises.push(refreshBtfActionBoxes(pageTitleId))
  } else if (canonicalTitleId) {
    promises.push(refreshEpisode(canonicalTitleId))
  }

  await Promise.all(promises);

  // Re-prepare player after purchase to update whisper cache
  const state = store.getState()
  const useNodePlayer = state.features.usePlayer

  if(!useNodePlayer) {
    const whisperCacheData = whisperCacheDataSelector(state)

    const modules = await auiModules({
      moduleNames: ['dv-player-integration'],
      timeout: 60000,
      logger,
    })

    const auiPlayer = modules && modules[0] as Player
    auiPlayer && whisperCacheData && auiPlayer.prepare(whisperCacheData)
  }
}


// TODO look if we could reduce number of params to this action creator
// we should probably only have offerAsin, the rest being retrieved directly from the store via selectors
// AVWebDetailPage-3129

export const triggerAuiPurchase = (dispatch: Dispatch) => async (
  logger: Logger,
  pageTitleId: string,
  canonicalTitleId: string | undefined,
  tvodAction: WpsRuntime.atv.wps.PurchaseActionProps,
  refTag: string,
  dataAttrs: object
) => {
  const { asin: offerAsin, purchaseData, csrfToken, offerToken } = tvodAction
  const purchasingTransitionArgs = {
    canonicalTitleId,
    offerAsin,
    isSeasonPurchase: purchaseData.isSeasonPurchase,
    purchasingText: purchaseData.text || '',
    errorHeader: purchaseData.modalText || '',
  }

  const purchaseOptions = {
    ...purchaseData,
    ...dataAttrs,
    asin: offerAsin,
    pinVerification: { csrfToken },
    purchaseArgs: {
      refTag,
      offerToken,
      csrfToken,
      asin: offerAsin
    }
  }

  const refreshAfterPurchaseArgs = {
    canonicalTitleId,
    pageTitleId,
    offerAsin,
    isSeasonPurchase: purchaseData.isSeasonPurchase,
    logger
  }

  parallelPurchases += 1
  logger.count(COUNTER_PARALLEL_PURCHASES, parallelPurchases, false)
  dispatch(triggerPurchasingTransition(purchasingTransitionArgs))
  startPurchase({ logger, options: purchaseOptions })
    .then(args => {
      parallelPurchases -= 1
      if (args && args.reload === false) {
        dispatch(
          resetPurchasingTransition({
            offerAsin,
            canonicalTitleId
          })
        )
      } else {
        refreshAfterPurchaseActionDispatcher(refreshAfterPurchaseArgs)
      }
    })
    .catch(err => {
      logger.error(err)
      parallelPurchases -= 1
      if (err && err.reason === PurchaseError.AUI_DEPENDENCY) {
        dispatch(
          failedPurchasingDueToClientDependency({
            offerAsin,
            canonicalTitleId
          })
        )
      }
    })
}
